<dashboardnav>
  
    <cradua-right-held
        [righthelds]="righthelds$ | async"
        (rightheld)="onSubmitRightHeld($event)"
        (deleteRightHeldEvent)="onDeleteRightHeld($event)"
        *ngIf="(isLoading$ | async ) === false"
        >
  </cradua-right-held>
  
    <mrsoftapps-epims-reference-spinner
    *ngIf="(isLoading$ | async) === true"
  >
    </mrsoftapps-epims-reference-spinner>
    <!-- <pre>{{isLoading$ | async | json}}</pre> -->
  </dashboardnav>
  